import { Pipe, PipeTransform } from '@angular/core';
import { JustTime, jsonCopyObject, justTimeToHHMM, justTimeToHHMMSS } from 'globals/helpers/helpers';
import { CueSheet } from 'globals/store/programs.data';

@Pipe({
    name: 'justTimeToHHMM',
    standalone: true
})
export class JustTimeToHHMM implements PipeTransform {
  transform(time?: JustTime, isClockTime: boolean = false): string { 
    return justTimeToHHMM(time, isClockTime)
  }
}

@Pipe({
    name: 'justTimeToHHMMSS',
    standalone: true
})
export class JustTimeToHHMMSS implements PipeTransform {
  transform(time: JustTime): string { 
    if (!time) return "0:00:00"
    if (!time.h) time.h = 0
    if (!time.m) time.m = 0
    if (!time.s) time.s = 0
    return justTimeToHHMMSS(time)
  }
}

@Pipe({
    name: 'cueJustTime',
    standalone: true
})
export class CueJustTime implements PipeTransform {
  transform(cue: CueSheet, row: number): string {
    let seconds = 0
    cue.rows.slice(0, row).map(r => r.duration).filter(d => !!d).forEach(({ h, m, s }) => {
      h = h || 0
      m = m || 0
      s = s || 0
      seconds += s + m * 60 + h * 3600
    })
    const s = seconds % 60
    const minutes = Math.round((seconds - s) / 60)
    const m = minutes % 60
    const h = Math.round((minutes - m) / 60)
    return justTimeToHHMMSS({ h, m, s })
  }
}